import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import { message } from 'antd';
import moment from 'moment';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import ventaClienteService from '../../../service/ventas/ventaClienteService';
import clienteService from '../../../service/administracion/clienteService';
import monedaService from '../../../service/administracion/monedaService';
import ubigeoService from '../../../service/integracion/ubigeoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            clientes: [],
            monedas: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idMoneda: 0,
                cliente: '',
                tipoReporte: 1,
                tipoComprobante: 1,
                idUsuario: 0,// auth.user().flagPermisoMV ? 0 : auth.user().id,
                ...FILTER
            },
            columnVisible: {
                tipo: 'hide',
                serie: 'hide',
                documento: 'hide',
                fecha: 'hide',
                tipoCambio: 'hide',
                grupoConversionDolares: 'hide',
                subTotalConversionDolares: 'hide',
                igvConversionDolares: 'hide',
                totalConversionDolares: 'hide'
            },
            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idMoneda: 0,
            cliente: '',
            tipoReporte: 1,
            tipoComprobante: 1,
            idDepartamento: 0,
            idProvincia: 0,
            idDistrito: 0,
            ...FILTER
        };
        this.setState({ filter, provincias: [], distritos: [] });
        this._handlePagination(filter);
    };

    handleChange = async (property, value) => {

        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                provincias: provincias ? provincias : [],
                distritos: [],
                filter: {
                    ...this.state.filter,
                    idProvincia: 0,
                    idDistrito: 0
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                distritos: distritos ? distritos : [],
                filter: {
                    ...this.state.filter,
                    idDistrito: 0
                }
            });
        }
     
        const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };
    
        const { fechaInicioStr, fechaFinStr } = filter;
    
        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
          const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
          const fin = moment(fechaFinStr, 'DD/MM/YYYY');
    
          const meses = fin.diff(inicio, 'months', true);
    
          if (meses > MAX_MESES) {
            message.error('El rango máximo permitido es de 18 meses');
            return; // ⛔ no actualiza el estado
          }
        }
    
        this.setState({ filter: filter });
    };





    handleExportExcel = async () => {
        this.setState({
            loadingExcel: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaClienteService.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas por Cliente.xlsx");
        });
    };

    handleExportPdf = async () => {
        this.setState({
            loadingPdf: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await ventaClienteService.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas por Cliente.pdf");
        });

    };

    handleExportPdfRegistrado = async () => {
        this.setState({
            loadingPdfRegistrado: true,
            filter: {
                ...this.state.filter, flagRegistrado: true
            }
        }, async () => {
            var response = await ventaClienteService.pdf(this.state.filter);
            this.setState({ loadingPdfRegistrado: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Ventas por Cliente (Registrados).pdf");
        });
    };

    handlePagination = () => {
        this._handlePagination(this.state.filter, () => {
            this.setState({
                columnVisible: {
                    ...this.state.columnVisible,
                    tipo: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    serie: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    documento: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    fecha: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipoCambio: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',

                    grupoSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    subTotalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    igvConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    totalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',

                    grupoConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    subTotalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    igvConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    totalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide'
                },
            })
        });
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };
    async componentDidMount() {
        this._initPagination(this.state.filter, ventaClienteService.paginacion);
        var clientes = await clienteService.listar();
        var monedas = await monedaService.listar();
        const departamentos = await ubigeoService.departamentos();

        if (monedas !== undefined)
            monedas.splice(0, 0, { id: '0', nombre: "MONEDA ORIGINAL" });

        this.setState({
            loadingSource: false,
            clientes: clientes ? clientes : [],
            monedas: monedas ? monedas : [],
            departamentos: departamentos ? departamentos : [],

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte de Ventas por Cliente"
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    //clientes={this.state.clientes}
                    monedas={this.state.monedas}
                    departamentos={this.state.departamentos}
                    provincias={this.state.provincias}
                    distritos={this.state.distritos}
                    onChange={this.handleChange}
                    onKeyUpSearch={this.handleKeyUpInput}

                />
                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    // onExportPdfRegistrado={this.handleExportPdfRegistrado}
                    onChange={this._handleChangePagination}
                />
            </div>
        )
    }
}